<app-transaction-history
  [entityId]="merchantId"
  [config]="transactionHistoryConfig"
  [transactionService]="merchantTransactionService"
  [initialSearch]="initialSearch"
  (transactionSelected)="onTransactionSelected($event)"
  (transactionUpdated)="onTransactionUpdated($event)"
>
</app-transaction-history>
